import React from 'react';
import { useSelector } from 'react-redux';
import CenterPanel from './centerPanel';
import RightPanel from './rightPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

export default function MeetingRoomResetGuestLinkModal(props) {
  const timezoneOffsetNow = useSelector((state) => state.usersReducer.userProfile.timezoneOffsetNow);

  let subtitle = '';

  if (props.selectedMeetingRoom) {
    subtitle = props.selectedMeetingRoom.name + ' (' + props.selectedMeetingRoom.organisationAbbreviatedName + ')';
  }

  return (
    <Modal show={true} hideWhenClickAway={false} className="reset-guest-link-meeting-room">
      <PopupHeader
        title={APP.LANGUAGE.ResetGuestLink.Title}
        subtitle={subtitle}
        helpLink={APP.EXTERNAL_LINKS.ViewMeetingRoom.HelpResetLink}
      />
      <div className="content">
        <div className="main-ui-container reset-meeting-room-link">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanel selectedMeetingRoom={props.selectedMeetingRoom} />
              </div>
            </div>
            <CenterPanel selectedMeetingRoom={props.selectedMeetingRoom} timezoneOffsetNow={timezoneOffsetNow} />
            <div className="bottom-rail-with-left-and-right-content mrtl">
              <RightPanel selectedMeetingRoom={props.selectedMeetingRoom} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
